var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD16GalleryBlock = function SvgD16GalleryBlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "d-16-gallery-block_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d-16-gallery-block_svg__a)",
    transform: "translate(.5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.845 10.044V4.886h-.79C2.47 4.886 2 5.363 2 5.947v6.974c0 .584.47 1.056 1.054 1.056h6.974c.584 0 1.064-.472 1.064-1.056v-.762H5.96a2.126 2.126 0 0 1-2.115-2.115z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.934 2.013H5.96A1.06 1.06 0 0 0 4.899 3.07v6.974c0 .584.477 1.06 1.06 1.06h6.975a1.06 1.06 0 0 0 1.057-1.06V3.07c0-.584-.474-1.057-1.057-1.057zm-.144 7.445a.33.33 0 0 1-.292.171H6.522a.33.33 0 0 1-.266-.13.33.33 0 0 1-.052-.294l.855-2.827a.51.51 0 0 1 .903-.147L9.158 7.91a.51.51 0 0 0 .701.126l1.1-.747a.508.508 0 0 1 .714.143l1.103 1.688a.328.328 0 0 1 .014.338z"
  })))));
};
export default SvgD16GalleryBlock;